export default "__VITE_ASSET__i6jM2ZYd__"